<template>
  <div class="home-box">
    <PageTitle :title="'Create New Product Category'" class="py-5"></PageTitle>
    <v-row align="center">
      <v-overlay :value="loading" :opacity="1" :color="'#FFFFFF'">
        <v-progress-circular
          color="#FFB300"
          indeterminate
          size="64"
        ></v-progress-circular>
      </v-overlay>
      <div class="col-md-12 home-tabs-body">
        <productCategoryForm />
      </div>
    </v-row>
  </div>
</template>

<script>
import productCategoryForm from "@/components/productCategory/productCategoryForm.vue";
import PageTitle from "@/components/shared/PageTitle";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");

export default {
  name: "ProductCategoryForm",
  components: {
    productCategoryForm,
    PageTitle,
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapGetters({
      profile: "profile",
    }),
  },
  mounted() {
    this.$store.dispatch("auth/getProfile");
  },
};
</script>
